export default __webpack_public_path__ + "static/media/about-us.b4ca11d1.png";